import  ReactGA from 'react-ga4'
import { useLocation } from "react-router-dom"
import { useEffect } from 'react'

const GA = () => {
    useEffect(()=>{
        ReactGA.initialize([{trackingId: "G-GHMZ1C8YG8"},{trackingId: "UA-231274821-1"}]);
    })

    const location = useLocation();

    useEffect(()=>{
        ReactGA.send({
            hitType: "pageview", 
            page: location.pathname + location.search
        })
    },[location])

    return null;
}

export default GA;
